module.exports = __webpack_public_path__ + "2b0003d6af98a87f314144ea789a75b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00000XBO.png
// module id = 1462
// module chunks = 0